import ClassroomsLicenseReviewModal from "~/components/Classrooms/LicenseReview/Modal.vue";

export const useShowClassroomsLicenseReviewModal = () => {
  if (useAppUserData().isLoggedIn != true) {
    return;
  }

  const { open, close } = useDialog({
    component: ClassroomsLicenseReviewModal,
    allowClose: false,
    showHeader: false,
    props: {
      onClose: () => {
        close();
      },
    },
  });

  open();
};
